import { Box } from '@mantine/core';
import { Outlet, createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_auth/author/_author/abstract/_abstract')({
  component: RouteComponent,
  staticData: {
    pageTitle: { id: 'sidebar.abstracts' },
  },
});

function RouteComponent() {
  return (
    <Box p="md">
      <Outlet />
    </Box>
  );
}
